import { render, staticRenderFns } from "./campaignVideoLinkInput.vue?vue&type=template&id=095647bd&scoped=true&"
import script from "./campaignVideoLinkInput.vue?vue&type=script&lang=js&"
export * from "./campaignVideoLinkInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095647bd",
  null
  
)

export default component.exports